import { useMutation, useQueryClient } from '@tanstack/react-query';
import { commentsApi } from '../api/commentsApi';

interface UseAddCommentOptions {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}

export const useAddComment = (issueKey: string, options: UseAddCommentOptions = {}) => {
  const queryClient = useQueryClient();
  const { onSuccess: onSuccessCallback, onError: onErrorCallback } = options;

  return useMutation({
    mutationFn: (text: string) => commentsApi.addComment(issueKey, text),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['comments', issueKey] });
      if (onSuccessCallback) {
        onSuccessCallback();
      }
    },
    onError: (error: Error) => {
      console.error('Error adding comment:', error);
      if (onErrorCallback) {
        onErrorCallback(error);
      }
    },
  });
};
